import { render, staticRenderFns } from "./payment-status-component.vue?vue&type=template&id=0485137c&scoped=true"
import script from "./payment-status-component.vue?vue&type=script&lang=js"
export * from "./payment-status-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0485137c",
  null
  
)

export default component.exports